import { useFieldHelper, FieldProps } from 'framework/ui/field';
import { Badge, Tooltip } from 'framework/ui/mui-builder';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { getConfirmationChipTooltip } from '../expertiseSection.utils';
import { EmployeeExpertise } from '../service/expertiseService.types';
import { ExpertiseStatus } from '../service/expertiseService.model';

const ConfirmChipField = (props: FieldProps) => {
  const { getData } = useFieldHelper(props);
  const expertise = getData() as EmployeeExpertise;
  const { getMomentDateObj, formatDate } = useDateService();

  const confirmDateString = expertise.confirmedAt;
  const tooltipDate = confirmDateString ? getMomentDateObj(confirmDateString) : getMomentDateObj(expertise.createdAt);
  const tooltipDateString = formatDate(tooltipDate, DATE_FORMAT.FULL_DATE) ?? '';
  const tooltipTitle = getConfirmationChipTooltip(expertise, tooltipDateString);
  const confirmed = expertise.status === ExpertiseStatus.CONFIRMED;

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <Badge color={confirmed ? 'success' : 'default'}>{confirmed ? 'Confirmed' : 'Not Confirmed'}</Badge>
    </Tooltip>
  );
};

export default ConfirmChipField;
